import React from 'react';
import {Formatted, Video} from 'components';
import {capitalize, config} from 'helpers';

export function Vision() {
  return (
    <Formatted className="medium-spacing">
      <Video.Video src={config.videos.identity.vision} />
      <div className="medium-spacing">
        In the previous sections of the {capitalize(config.identityModule)} Wizard, you have questioned and stretched, you have explored and found.
        This final section is about synthesizing all that information and creating your life vision.
        Your life vision is a mental and emotional picture of the life you desire.
        It embodies not only what you want to do, but how you want to do it and who you want to be in the world.
        A clear life vision will be the backbone of the next two modules of { config.appName } by energizing and motivating you to take action and make this vision your reality.
      </div>
    </Formatted>
  );
}
